@let _inputs = inputs();

@if (_inputs) {
  <div class="dropdown-position" [ngStyle]="style()" (clickOutside)="destroy()">
    <ng-container *ngComponentOutlet="dropdownClass; inputs: _inputs"></ng-container>
  </div>
}
